/*
 * ============================================================
 * argile-quantite-finder.js — modale « Calculer la quantité nécessaire »
 * ============================================================
 * Chargé par snippets/argile-quantite-finder.liquid (rendu global). Réutilise la
 * coquille/CSS `argile-finder__*` ; logique propre au calcul de quantité.
 *
 * Flux : q1 (surfaces L×H, ajout/soustraction, superficie live) →
 * finition (choix parmi les 11 finitions) → q2 (état du support) →
 * final (résultat : peinture + sous-couche recommandée).
 *
 * Calcul — fiches techniques Argile (rendements confirmés client 2026-07-08) :
 *   surface nette = Σ(L×H surfaces) − Σ(L×H ouvertures)
 *   volume peinture (L) = surface_nette / rendement_finition × COUCHES × (1 + MARGE)
 *   conditionnement = parmi les combinaisons de formats couvrant au moins le besoin,
 *     la MOINS CHÈRE aux prix live (à prix égal : le moins de pots, puis le moins
 *     de surplus) ; sans prix connu, plus petit pot unique couvrant le besoin, sinon
 *     n × plus grand format + 1 complément.
 *   sous-couche (info) = surface_nette / rendement_sc × 1 couche × (1 + MARGE)
 *
 * Toutes les valeurs métier (rendements, conditionnements, règles de préparation)
 * sont regroupées ci-dessous — un seul point de vérité, facile à ajuster.
 */
(function () {
  'use strict';

  var COATS = 2; // nombre de couches recommandé pour toutes les finitions
  var MARGIN = 0.1; // marge de sécurité reprises (10 %)

  /* Rendement par finition, en m²/L — valeurs des fiches techniques, confirmées par
     le client le 2026-07-08 (elles remplacent les rendements minorés de l'onglet
     « Simulateur » de la calculatrice Excel). */
  var RENDEMENTS = {
    AMP: 10, AMV: 12, ALM: 12, ASC: 12, ALSI: 12,
    ANM: 12, ANV: 12, ANS: 12, AMVE: 12, ALSE: 10, ABP: 13,
  };

  /* Conditionnements disponibles (L) par finition — feuille « Données Produits »
     colonne Conditionnements. Triés croissant. */
  var CONDS = {
    AMP: [0.75, 2.5, 5, 10], AMV: [0.75, 2.5, 5, 10], ALM: [0.75, 2.5, 5, 10],
    ASC: [0.75, 2.5, 5, 10], ALSI: [0.75, 2.5, 5],
    ANM: [0.75, 2.5, 5], ANV: [0.75, 2.5, 5], ANS: [0.75, 2.5, 5],
    AMVE: [0.75, 2.5, 5, 10], ALSE: [0.75, 2.5, 5], ABP: [5, 10],
  };

  /* Sous-couches : rendement (m²/L, fiches techniques — cf. RENDEMENTS) +
     conditionnements (L). */
  var SUBS = {
    ASCP: { name: 'Argile Sous Couche de Préparation', rendement: 10, conds: [2.5, 5, 10] },
    APU: { name: 'Argile Primaire Universel', rendement: 12, conds: [0.75, 2.5, 5] },
    AIN: { name: 'Argile Nature Impression', rendement: 10, conds: [0.75, 2.5, 5] },
  };

  /* Prix unitaires TTC par code × format (L) — construits À CHAUD depuis le catalogue
     Shopify. SOURCE DE VÉRITÉ = prix réels en boutique (plus de table tarifaire à
     resynchroniser à la main, plus de dérive estimation ↔ panier). Forme :
     { CODE: { litres: € } }. Renseigné par loadCatalog() ; null tant que le catalogue
     n'est pas chargé → priceOf() renvoie null et l'affichage du prix est omis.
       • Finitions teintes (10 finitions colorées) : variantes Finition × Litrage.
       • Blanc Plafond + sous-couches : produits autonomes reconnus par mot-clé de titre
         (STANDALONE_MATCH), un format par variante « Contenance » (litrage lu sur la
         variante, sinon dans le titre).
     NB : les prix /products.json sont des chaînes décimales en euros (« 263.40 »),
     PAS des centimes → parseFloat, jamais /100. */
  var LIVE_PRICES = null;

  /* i18n injecté par le Liquid (data-argile-qf-i18n) + flag prix (devise). */
  var I18N = {};
  var PRICES_ENABLED = true;

  /* Reconnaissance des produits autonomes (sans option Finition×Litrage) par code. */
  var STANDALONE_MATCH = {
    ASCP: /sous.?couche/i,
    APU: /primaire universel/i,
    AIN: /impression nature|nature impression/i,
    ABP: /blanc plafond/i,
  };

  function priceNumber(raw) {
    var n = parseFloat(String(raw == null ? '' : raw).replace(',', '.'));
    return isNaN(n) ? null : n;
  }

  function buildLivePrices(products) {
    var byCode = {};
    // Nom de finition normalisé → code GAMMES (résolution des variantes teintes).
    var finToCode = {};
    Object.keys(FIN_NAME).forEach(function (code) { finToCode[normalizeFin(FIN_NAME[code])] = code; });
    function put(code, lit, eur) {
      if (code == null || isNaN(lit) || eur == null) return;
      if (!byCode[code]) byCode[code] = {};
      if (byCode[code][lit] == null) byCode[code][lit] = eur; // première occurrence
    }
    (products || []).forEach(function (p) {
      var opts = p.options || [], finPos = 0, litPos = 0;
      for (var i = 0; i < opts.length; i++) {
        var nm = (opts[i] && (opts[i].name || opts[i])) || '';
        if (/finition/i.test(nm)) finPos = (opts[i].position || i + 1);
        else if (/litrage|litre|conditionn/i.test(nm)) litPos = (opts[i].position || i + 1);
      }
      if (finPos && litPos) {
        // Teinte : prix par finition (code) × litrage.
        (p.variants || []).forEach(function (v) {
          put(finToCode[normalizeFin(v['option' + finPos])], litresFromLabel(v['option' + litPos]), priceNumber(v.price));
        });
      } else {
        // Produit autonome : sous-couche / Blanc Plafond. Depuis le passage des produits de
        // préparation en variantes « Contenance » (un produit, un format par variante), le
        // litrage se lit sur CHAQUE variante ; repli sur le titre du produit pour l'ancien
        // modèle « un produit par litrage ». Sans ce repli variante, ces quatre codes
        // n'avaient plus aucun prix live (constaté le 22/09/2026 sur FR et UK).
        for (var c in STANDALONE_MATCH) {
          if (STANDALONE_MATCH[c].test(p.title || '')) {
            (p.variants || []).forEach(function (v) {
              var lit = litresFromLabel(v.title);
              if (isNaN(lit)) lit = litresFromLabel(p.title);
              put(c, lit, priceNumber(v.price));
            });
            break;
          }
        }
      }
    });
    return byCode;
  }

  /* Prix live brut (devise de base de la boutique) d'un format pour un code (finition
     ou sous-couche), ou null si inconnu (catalogue non chargé, ou format non tarifé en
     boutique). Sert au CHOIX du conditionnement : un classement par prix reste juste
     quelle que soit la devise présentée. */
  function livePrice(code, pot) {
    if (!LIVE_PRICES) return null;
    var byLit = LIVE_PRICES[code];
    return byLit && byLit[pot] != null ? byLit[pot] : null;
  }
  /* Prix unitaire à AFFICHER, ou null si l'affichage des prix est coupé (devise
     présentée ≠ devise de base, cf. data-prices-enabled). */
  function priceOf(code, pot) {
    return PRICES_ENABLED ? livePrice(code, pot) : null;
  }

  /* Les 11 finitions sélectionnables, regroupées par gamme (ordre d'affichage).
     `sub` = règle de préparation par état de support (neuf / mate / brillant) :
       { code: 'ASCP'|'APU'|'AIN'|null, text: '…' }
       code null = pas de sous-couche dédiée (dilution, nettoyage…) → texte seul. */
  var GAMMES = [
    {
      name: 'Classique',
      items: [
        { code: 'AMP', name: 'Argile Mat Profond', note: 'Pièces à usage normal' },
        { code: 'AMV', name: 'Argile Mat Velouté', note: 'Pièces à vivre' },
        { code: 'ALM', name: 'Argile Laque Mate', note: 'Toutes pièces, lessivable' },
        { code: 'ASC', name: 'Argile Satin Couvrant', note: 'Très garnissant' },
        { code: 'ALSI', name: 'Argile Laque Satinée Intérieure', note: 'Haute résistance, lessivable' },
      ],
    },
    {
      name: 'Nature',
      items: [
        { code: 'ANM', name: 'Argile Nature Mat', note: 'Résine biosourcée 96 %' },
        { code: 'ANV', name: 'Argile Nature Velours', note: 'COV < 1 g/L' },
        { code: 'ANS', name: 'Argile Nature Satin', note: 'Toutes pièces, lessivable' },
      ],
    },
    {
      name: 'Extérieure',
      items: [
        { code: 'AMVE', name: 'Argile Mat Velouté Extérieur', note: 'Façades et boiseries' },
        { code: 'ALSE', name: 'Argile Laque Satinée Extérieure', note: 'Boiseries extérieures' },
      ],
    },
    {
      name: 'Technique',
      items: [
        { code: 'ABP', name: 'Argile Blanc Plafond', note: 'Plafonds intérieurs' },
      ],
    },
  ];

  /* Index code → nom de finition (pour la résolution des prix live, cf. priceOf). */
  var FIN_NAME = {};
  GAMMES.forEach(function (g) { g.items.forEach(function (it) { FIN_NAME[it.code] = it.name; }); });

  /* Règles de sous-couche par finition × état du support. */
  var SUB_RULES = {
    // Gamme Classique
    AMP: { neuf: { code: 'ASCP' }, mate: { code: 'ASCP' }, brillant: { code: 'APU' } },
    AMV: { neuf: { code: 'ASCP' }, mate: { code: 'ASCP' }, brillant: { code: 'APU' } },
    ALM: { neuf: { code: 'ASCP' }, mate: { code: 'ASCP' }, brillant: { code: 'APU' } },
    ASC: { neuf: { code: 'ASCP' }, mate: { code: 'ASCP' }, brillant: { code: 'APU' } },
    ALSI: { neuf: { code: 'ASCP' }, mate: { code: 'ASCP' }, brillant: { code: 'APU' } },
    // Gamme Nature
    ANM: { neuf: { code: 'AIN' }, mate: { code: 'AIN' }, brillant: { code: 'AIN', tk: 'nature_gloss' } },
    ANV: { neuf: { code: 'AIN' }, mate: { code: 'AIN' }, brillant: { code: 'AIN', tk: 'nature_gloss' } },
    ANS: { neuf: { code: 'AIN' }, mate: { code: 'AIN' }, brillant: { code: 'AIN', tk: 'nature_gloss' } },
    // Gamme Extérieure
    AMVE: {
      neuf: { code: null, tk: 'amve_neuf' },
      mate: { code: null, tk: 'amve_mate' },
      brillant: { code: 'APU', tk: 'amve_brillant' },
    },
    ALSE: {
      neuf: { code: null, tk: 'alse_neuf' },
      mate: { code: 'APU', tk: 'alse_mate' },
      brillant: { code: 'APU' },
    },
    // Gamme Technique
    ABP: {
      neuf: { code: null, tk: 'abp' },
      mate: { code: null, tk: 'abp' },
      brillant: { code: 'APU' },
    },
  };

  /* Textes par défaut quand la règle ne précise pas de `text`. */
  var SUB_DEFAULT_TEXT = {
    ASCP: 'Appliquez d’abord une sous-couche de préparation.',
    APU: 'Appliquez d’abord un primaire universel (accroche sur supports brillants ou non absorbants).',
    AIN: 'Appliquez d’abord l’Impression Nature.',
  };

  var SUPPORT_LABELS = {
    neuf: 'Support neuf ou brut',
    mate: 'Déjà peint, finition mate',
    brillant: 'Déjà peint, brillant ou satiné',
  };

  /* ---- Helpers de formatage FR ---- */
  function frArea(v) { return (v || 0).toFixed(2).replace('.', I18N.decimalSep || ','); }
  function frNum(v) {
    // 2 décimales max, sans zéros inutiles : 0,75 / 2,5 / 5 / 10,5
    var s = (Math.round((v || 0) * 100) / 100).toString();
    return s.replace('.', I18N.decimalSep || ',');
  }
  function potLabel(p) { return frNum(p) + ' L'; }
  /* « 0,75 L » / « 2,5L » → litres (Number) ou NaN. */
  function litresFromLabel(label) {
    if (label == null) return NaN;
    var m = String(label).replace(',', '.').match(/([\d.]+)/);
    return m ? parseFloat(m[1]) : NaN;
  }
  /* Normalise une finition pour comparaison robuste (calculatrice ↔ option produit). */
  function normalizeFin(s) {
    return String(s || '').toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/\bargile\b/g, '').replace(/\s+/g, ' ').trim();
  }

  /* ---- Calcul du volume nécessaire (L) pour une finition donnée ---- */
  function paintVolume(area, code) {
    var rend = RENDEMENTS[code];
    if (!rend || area <= 0) return 0;
    return area / rend * COATS * (1 + MARGIN);
  }
  function subVolume(area, subCode) {
    var sub = SUBS[subCode];
    if (!sub || area <= 0) return 0;
    return area / sub.rendement * 1 * (1 + MARGIN); // 1 couche pour la sous-couche
  }

  /* ---- Optimisation du conditionnement ----
     Retourne [{ pot, n }], plus grand format en tête.
     Règle (retour client 09/2026 — 30 m² Laque Mate = 5,5 L donnait 1 × 10 L à 355 €
     alors que 5 L + 0,75 L couvre le besoin pour 270,10 €) : parmi les combinaisons de
     formats qui couvrent AU MOINS le besoin, la MOINS CHÈRE ; à prix égal, celle qui
     compte le moins de pots ; à égalité encore, celle qui laisse le moins de surplus.
     Les prix viennent du catalogue live (livePrice). Seuls les formats tarifés en
     boutique entrent dans la recherche. Sans aucun prix connu (catalogue pas encore
     chargé) → règle historique du « pot minimal suffisant » (minimalPackaging) ;
     renderResult se réaffiche à l'arrivée du catalogue. */
  function recommendPackaging(volume, pots, code) {
    if (volume <= 0 || !pots || !pots.length) return [];
    var priced = pots.filter(function (p) { return livePrice(code, p) != null; });
    if (priced.length) return cheapestPackaging(volume, priced, code);
    return minimalPackaging(volume, pots);
  }

  /* Combinaison la moins chère couvrant au moins `volume` L — programmation dynamique
     sur le volume, en pas de `step` cL (PGCD des formats : 25 cL pour 0,75/2,5/5/10 L).
     Pour chaque volume v (en pas) on garde le meilleur triplet (coût en centimes, nombre
     de pots, volume) couvrant au moins v. L'ordre lexicographique est additif composante
     par composante, donc la sous-structure optimale tient et la recherche est exacte. */
  function cheapestPackaging(volume, pots, code) {
    var asc = pots.slice().sort(function (a, b) { return a - b; });
    var cl = asc.map(function (p) { return Math.round(p * 100); });
    var step = cl.reduce(gcd);
    var units = cl.map(function (c) { return c / step; });
    var cents = asc.map(function (p) { return Math.round(livePrice(code, p) * 100); });
    var need = Math.ceil(Math.round(volume * 1e6) / 1e4 / step); // L → cL (arrondi 1e-6 L) → pas
    var cost = [0], count = [0], vol = [0], pick = [-1];
    for (var v = 1; v <= need; v++) {
      cost[v] = Infinity; count[v] = Infinity; vol[v] = Infinity; pick[v] = -1;
      for (var i = 0; i < asc.length; i++) {
        var prev = Math.max(0, v - units[i]);
        var c = cost[prev] + cents[i], n = count[prev] + 1, u = vol[prev] + units[i];
        if (c < cost[v] || (c === cost[v] && (n < count[v] || (n === count[v] && u < vol[v])))) {
          cost[v] = c; count[v] = n; vol[v] = u; pick[v] = i;
        }
      }
    }
    var byPot = {};
    for (var w = need; w > 0; w = Math.max(0, w - units[pick[w]])) {
      byPot[pick[w]] = (byPot[pick[w]] || 0) + 1;
    }
    return Object.keys(byPot).map(function (i) { return { pot: asc[i], n: byPot[i] }; })
      .sort(function (a, b) { return b.pot - a.pot; });
  }
  function gcd(a, b) { return b ? gcd(b, a % b) : a; }

  /* Règle historique du « pot minimal suffisant » (sans prix) : plus petit pot unique
     couvrant le besoin, sinon n × plus grand format + 1 complément (plus petit pot
     couvrant le reste). */
  function minimalPackaging(volume, pots) {
    var asc = pots.slice().sort(function (a, b) { return a - b; });
    var largest = asc[asc.length - 1];
    if (volume <= largest + 1e-9) {
      for (var i = 0; i < asc.length; i++) {
        if (asc[i] >= volume - 1e-9) return [{ pot: asc[i], n: 1 }];
      }
    }
    var nLarge = Math.floor(volume / largest);
    var rem = volume - nLarge * largest;
    var combo = [{ pot: largest, n: nLarge }];
    if (rem > 1e-9) {
      var comp = null;
      for (var j = 0; j < asc.length; j++) {
        if (asc[j] >= rem - 1e-9) { comp = asc[j]; break; }
      }
      if (comp == null) comp = largest;
      if (comp === largest) combo[0].n += 1;
      else combo.push({ pot: comp, n: 1 });
    }
    return combo;
  }
  function packagingLabel(combo) {
    if (!combo.length) return '—';
    return combo.map(function (c) {
      return c.n + ' ' + (c.n > 1 ? I18N.tinMany : I18N.tinOne) + ' ' + I18N.tinOf + ' ' + potLabel(c.pot);
    }).join(' + ');
  }
  /*
   * Formate un montant selon la devise du MARCHÉ courant (I18N.currency, posé par
   * argile-quantite-finder.liquid).
   *
   * L'euro est rendu à l'identique de l'origine — séparateur décimal de la locale,
   * espace avant le symbole — pour ne rien changer au catalogue français. La livre suit
   * la convention britannique : symbole devant, collé, point décimal.
   *
   * Le nom `frEur` est conservé : il est appelé en cinq endroits et le renommer
   * n'apporterait rien de plus que du bruit dans le diff.
   */
  function frEur(v) {
    var n = (Math.round((v || 0) * 100) / 100).toFixed(2);
    if (I18N.currency === 'GBP') return '£' + n;
    if (I18N.currency && I18N.currency !== 'EUR') {
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: I18N.currency })
          .format(Math.round((v || 0) * 100) / 100);
      } catch (e) { /* devise inconnue : on retombe sur le rendu euro ci-dessous */ }
    }
    return n.replace('.', I18N.decimalSep || ',') + ' €';
  }
  /* Total € + €/L d'un conditionnement recommandé pour un code donné.
     Retourne null si un format du combo n'a pas de prix (pas d'affichage prix). */
  function packagingPrice(combo, code) {
    if (!combo.length) return null;
    var total = 0, liters = 0;
    for (var i = 0; i < combo.length; i++) {
      var unit = priceOf(code, combo[i].pot);
      if (unit == null) return null;
      total += unit * combo[i].n;
      liters += combo[i].pot * combo[i].n;
    }
    return { total: total, perL: liters > 0 ? total / liters : 0 };
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function initQuantite(root) {
    if (!root || root.dataset.wired) return;
    root.dataset.wired = '1';

    if (!I18N.__loaded) {
      var cfgEl = root.querySelector('[data-argile-qf-i18n]');
      if (cfgEl) { try { var parsed = JSON.parse(cfgEl.textContent); for (var ck in parsed) I18N[ck] = parsed[ck]; } catch (e) {} }
      I18N.__loaded = true;
    }
    PRICES_ENABLED = root.dataset.pricesEnabled !== 'false';
    var LROOT = root.dataset.localeRoot || '/';
    function locURL(p) { return LROOT !== '/' ? LROOT + p : p; }

    var SEQUENCE = ['q1', 'finition', 'q2', 'final'];
    var QUESTIONS = ['q1', 'finition', 'q2'];
    var steps = {};
    root.querySelectorAll('[data-finder-step]').forEach(function (el) {
      steps[el.getAttribute('data-finder-step')] = el;
    });
    var surfaceTpl = root.querySelector('[data-surface-template]');
    var subtractTpl = root.querySelector('[data-subtract-template]');
    var answers = {};
    var current = 'q1';
    var lastFocus = null;
    var lastReco = null; // { code, name, combo:[{pot,n}] } — pour CTA / sélecteur teinte
    var teintesCache = null; // produits teintes (catalogue products.json filtré)
    var catalogPromise = null; // promesse mémoïsée : teintes + prix live (LIVE_PRICES)

    function isFinal(id) { return id === 'final'; }
    function nextOf(id) { var i = SEQUENCE.indexOf(id); return SEQUENCE[Math.min(SEQUENCE.length - 1, i + 1)]; }
    function prevOf(id) { var i = SEQUENCE.indexOf(id); return SEQUENCE[Math.max(0, i - 1)]; }

    /* ---- Surfaces : superficie = Σ(L×H positives) − Σ(L×H soustraites) ---- */
    function rowArea(row) {
      var w = parseFloat((row.querySelector('[data-dim="w"]') || {}).value) || 0;
      var h = parseFloat((row.querySelector('[data-dim="h"]') || {}).value) || 0;
      return Math.max(0, w) * Math.max(0, h);
    }
    function area() {
      var add = 0, sub = 0;
      root.querySelectorAll('[data-surfaces] [data-surface]').forEach(function (s) { add += rowArea(s); });
      root.querySelectorAll('[data-subtracts] [data-subtract-row]').forEach(function (s) { sub += rowArea(s); });
      return Math.max(0, add - sub);
    }
    function renumber() {
      root.querySelectorAll('[data-surfaces] [data-surface]').forEach(function (s, i) {
        var n = s.querySelector('[data-surface-num]'); if (n) n.textContent = i + 1;
      });
      root.querySelectorAll('[data-subtracts] [data-subtract-row]').forEach(function (s, i) {
        var n = s.querySelector('[data-surface-num]'); if (n) n.textContent = i + 1;
      });
    }
    function updateTotal() {
      var a = area();
      var totalEl = root.querySelector('[data-total]');
      if (totalEl) totalEl.textContent = frArea(a);
      var note = root.querySelector('[data-surface-note]');
      if (note) note.hidden = a > 0;
      syncNextEnabled('q1');
    }

    /* ---- Étape finition : cartes générées depuis GAMMES ---- */
    /* Normalise un libellé de finition (comme argile-product.js) pour rapprocher
       la valeur du dropdown produit d'un code de finition du calculateur. */
    function normFin(s) {
      return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
        .replace(/\bargile\b/g, '').replace(/\s+/g, ' ').trim();
    }
    function finitionCodeFromName(name) {
      var want = normFin(name);
      if (!want) return null;
      for (var gi = 0; gi < GAMMES.length; gi++) {
        var items = GAMMES[gi].items;
        for (var ii = 0; ii < items.length; ii++) {
          if (normFin(items[ii].name) === want) return items[ii].code;
        }
      }
      return null;
    }
    /* Reflète answers.finition sur les cartes de l'étape 2 (pré-remplissage retour fiche). */
    function preselectFinition() {
      var code = answers.finition;
      if (!code) return;
      var host = root.querySelector('[data-finition-options]');
      if (!host) return;
      host.querySelectorAll('[data-finition-option]').forEach(function (o) {
        var on = o.dataset.code === code;
        o.classList.toggle('is-selected', on);
        o.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }

    function buildFinitions() {
      var host = root.querySelector('[data-finition-options]');
      if (!host || host.dataset.built) return;
      var html = '';
      GAMMES.forEach(function (g) {
        html += '<p class="argile-finder__gamme">' + escapeHtml(I18N.gammes[g.name] || g.name) + '</p>';
        html += '<div class="argile-finder__supports" role="radiogroup">';
        g.items.forEach(function (it) {
          html += '<button type="button" class="argile-finder__support" data-finition-option data-code="' +
            it.code + '" role="radio" aria-checked="false">' +
            '<span class="argile-finder__support-radio" aria-hidden="true"></span>' +
            '<span class="argile-finder__support-text"><strong>' + escapeHtml(it.name) +
            '</strong><span>' + escapeHtml(I18N.notes[it.code] || it.note) + '</span></span></button>';
        });
        html += '</div>';
      });
      host.innerHTML = html;
      host.dataset.built = '1';
      host.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-finition-option]');
        if (!opt) return;
        host.querySelectorAll('[data-finition-option]').forEach(function (o) {
          var on = o === opt;
          o.classList.toggle('is-selected', on);
          o.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        answers.finition = opt.dataset.code;
        syncNextEnabled('finition');
      });
    }

    /* ---- Contexte (m² → finition → support) ---- */
    function renderContext(id) {
      var el = steps[id] ? steps[id].querySelector('[data-finder-context]') : null;
      if (!el) return;
      var tags = [];
      if (id !== 'q1') tags.push(frArea(area()) + ' m²');
      if (id !== 'q1' && id !== 'finition' && answers.finition) {
        tags.push(findFinition(answers.finition).name);
      }
      if (id === 'final' && answers.support) tags.push(I18N.support[answers.support] || SUPPORT_LABELS[answers.support]);
      el.innerHTML = tags.map(function (t) {
        return '<span class="argile-finder__ctx-tag">' + escapeHtml(t) + '</span>';
      }).join('');
      el.hidden = !tags.length;
    }

    function findFinition(code) {
      for (var g = 0; g < GAMMES.length; g++) {
        for (var i = 0; i < GAMMES[g].items.length; i++) {
          if (GAMMES[g].items[i].code === code) {
            return { gamme: GAMMES[g].name, name: GAMMES[g].items[i].name, code: code };
          }
        }
      }
      return { gamme: '', name: code, code: code };
    }

    function updateHead(id) {
      var step = steps[id];
      if (!step) return;
      var pos = QUESTIONS.indexOf(id);
      if (pos < 0) return;
      var etapeEl = step.querySelector('[data-finder-etape]');
      var barEl = step.querySelector('.argile-finder__progress-bar');
      if (etapeEl) etapeEl.textContent = I18N.stepPrefix + ' ' + (pos + 1) + '/' + QUESTIONS.length;
      if (barEl) barEl.style.width = (((pos + 1) / QUESTIONS.length) * 100) + '%';
    }

    function syncNextEnabled(id) {
      var step = steps[id];
      if (!step) return;
      var next = step.querySelector('[data-finder-next]');
      if (!next) return;
      if (isFinal(id)) { next.disabled = false; return; }
      if (id === 'q1') { next.disabled = !(area() > 0); return; }
      if (id === 'finition') { next.disabled = !answers.finition; return; }
      if (id === 'q2') { next.disabled = !answers.support; return; }
    }

    /* ---- Rendu du résultat final ---- */
    function specHtml(label, value) {
      return '<div class="argile-finder__spec"><span class="argile-finder__spec-label">' +
        escapeHtml(label) + '</span><span class="argile-finder__spec-value">' +
        escapeHtml(value) + '</span></div>';
    }

    function renderResult() {
      var a = area();
      var code = answers.finition;
      var fin = findFinition(code);
      var resEl = root.querySelector('[data-quantite-result]');
      var subEl = root.querySelector('[data-quantite-sub]');

      /* — Peinture — */
      if (resEl) {
        var vol = paintVolume(a, code);
        var pots = (CONDS[code] || []).slice();
        var combo = recommendPackaging(vol, pots, code);
        lastReco = { code: code, name: fin.name, combo: combo };
        var condsRef = pots.map(function (p) {
          var inCombo = combo.filter(function (c) { return c.pot === p; })[0];
          var count = inCombo ? inCombo.n : Math.ceil(vol / p);
          var unit = priceOf(code, p);
          var sub = (unit != null ? frEur(unit) + ' · ' : '') + count + ' ' + (count > 1 ? I18N.tinMany : I18N.tinOne);
          return '<div class="argile-finder__cond-qty' + (inCombo ? ' is-selected' : '') + '">' +
            '<span class="argile-finder__cond-name">' + escapeHtml(I18N.tin) + ' ' + potLabel(p) + '</span>' +
            '<span class="argile-finder__cond-count">' + sub + '</span></div>';
        }).join('');
        var price = packagingPrice(combo, code);
        var priceMeta = price
          ? '<p class="argile-finder__result-meta">' + escapeHtml(I18N.pricePrefix) + ' <strong>' + escapeHtml(frEur(price.total)) +
            '</strong> <span>(' + escapeHtml(frEur(price.perL)) + '/L)</span></p>'
          : '';
        resEl.innerHTML =
          '<details class="argile-finder__result-acc" open>' +
            '<summary class="argile-finder__result-head">' +
              '<span class="argile-finder__result-main">' +
                '<span class="argile-finder__result-title">' + escapeHtml(fin.name) + '</span>' +
                '<span class="argile-finder__result-sub">' + escapeHtml(I18N.rangePrefix + ' ' + (I18N.gammes[fin.gamme] || fin.gamme)) + '</span>' +
              '</span>' +
              '<span class="argile-finder__rec-caret" aria-hidden="true"></span>' +
            '</summary>' +
            '<div class="argile-finder__result-body">' +
              '<div class="argile-finder__specs">' +
                specHtml(I18N.specNetArea, frArea(a) + ' m²') +
                specHtml(I18N.specVolume, frNum(vol) + ' L') +
                specHtml(I18N.specMargin, I18N.marginValue) +
              '</div>' +
              '<p class="argile-finder__result-meta">' + escapeHtml(I18N.packRecommended) + ' <strong>' +
                escapeHtml(packagingLabel(combo)) + '</strong></p>' +
              priceMeta +
              '<div class="argile-finder__conds">' + condsRef + '</div>' +
            '</div>' +
          '</details>';
      }

      /* — Sous-couche (info) — */
      if (subEl) {
        var rule = (SUB_RULES[code] || {})[answers.support] || {};
        var subCode = rule.code || null;
        var text = (rule.tk ? I18N.subtext[rule.tk] : (rule.text || '')) || (subCode ? (I18N.subtext['default_' + subCode] || SUB_DEFAULT_TEXT[subCode]) : '');
        var title, sub = subCode ? SUBS[subCode] : null;
        title = sub ? sub.name : I18N.prepTitle;
        var body = '<p class="argile-finder__result-desc">' + escapeHtml(text || I18N.prepNone) + '</p>';
        if (sub) {
          var sv = subVolume(a, subCode);
          var spots = (sub.conds || []).slice();
          var scombo = recommendPackaging(sv, spots, subCode);
          var sprice = packagingPrice(scombo, subCode);
          body +=
            '<div class="argile-finder__specs">' +
              specHtml(I18N.specUndercoatVolume, frNum(sv) + ' L') +
              specHtml(I18N.specPack, packagingLabel(scombo)) +
              (sprice ? specHtml(I18N.specPrice, frEur(sprice.total)) : '') +
            '</div>';
        }
        subEl.innerHTML =
          '<details class="argile-finder__result-acc">' +
            '<summary class="argile-finder__result-head">' +
              '<span class="argile-finder__result-main">' +
                '<span class="argile-finder__result-title">' + escapeHtml(title) + '</span>' +
                '<span class="argile-finder__result-sub">' + escapeHtml(I18N.support[answers.support] || SUPPORT_LABELS[answers.support] || '') + '</span>' +
              '</span>' +
              '<span class="argile-finder__rec-caret" aria-hidden="true"></span>' +
            '</summary>' +
            '<div class="argile-finder__result-body">' + body + '</div>' +
          '</details>';
      }

      /* Prix pas encore chargés (utilisateur rapide) → réaffiche dès l'arrivée du
         catalogue. LIVE_PRICES alors renseigné → pas de re-déclenchement en boucle. */
      if (!LIVE_PRICES) {
        loadCatalog().then(function () { if (current === 'final') { renderResult(); updateCta(); } }).catch(function () {});
      }
    }

    /* ---- Navigation ---- */
    function goto(id) {
      if (!steps[id]) return;
      current = id;
      Object.keys(steps).forEach(function (sid) {
        var on = sid === id;
        steps[sid].hidden = !on;
        steps[sid].classList.toggle('is-active', on);
      });
      if (id === 'finition') { buildFinitions(); preselectFinition(); }
      if (isFinal(id)) { renderResult(); updateCta(); }
      if (id === 'teinte') loadTeintes();
      renderContext(id);
      updateHead(id);
      syncNextEnabled(id);
      var content = steps[id].querySelector('.argile-finder__content');
      if (content) content.scrollTop = 0;
    }

    function reset() {
      root.querySelectorAll('[data-surfaces] [data-surface]').forEach(function (s, i) { if (i > 0) s.remove(); });
      root.querySelectorAll('[data-subtracts] [data-subtract-row]').forEach(function (s) { s.remove(); });
      root.querySelectorAll('[data-dim]').forEach(function (inp) { inp.value = 0; });
      root.querySelectorAll('[data-finder-option].is-selected, [data-finition-option].is-selected').forEach(function (o) {
        o.classList.remove('is-selected'); o.setAttribute('aria-checked', 'false');
      });
      answers = {};
      renumber();
      updateTotal();
    }

    /* Image de droite = image du hero de la page « Définir la quantité »
       (section argile-finder-intro, target quantite) si la modale est ouverte
       sur cette page → suit l'éditeur en direct. Partout ailleurs (produit,
       méga-menu…), fallback = image globale du réglage de thème. */
    function applyHeroImage() {
      var hero = document.querySelector('[data-finder-hero][data-finder-target="quantite"] img.argile-finder-intro__img');
      var src = (hero && (hero.currentSrc || hero.src)) || root.dataset.finderFallbackImage || '';
      root.querySelectorAll('.argile-finder__media').forEach(function (m) {
        m.style.backgroundImage = src ? 'url("' + src + '")' : '';
      });
    }

    /* Pot « principal » du combo recommandé (plus grand format). */
    function primaryPot() {
      if (!lastReco || !lastReco.combo.length) return null;
      return lastReco.combo.slice().sort(function (a, b) { return b.pot - a.pot; })[0];
    }

    /* Produit de la fiche d'origine (data-product-url) dans le catalogue chargé, ou null
       (catalogue pas encore là, ou produit sans options Finition × Litrage). */
    function originProduct() {
      var m = /\/products\/([^/?#]+)/.exec(root.dataset.productUrl || '');
      if (!m || !teintesCache) return null;
      var handle = decodeURIComponent(m[1]);
      return teintesCache.filter(function (p) { return p.handle === handle; })[0] || null;
    }
    /* Lignes panier du combo recommandé pour un produit : une par format, pots
       indisponibles ignorés. */
    function comboItems(product) {
      var items = [];
      if (!product || !lastReco) return items;
      lastReco.combo.forEach(function (c) {
        var v = resolveVariant(product, lastReco.name, c.pot);
        if (v && v.available !== false) items.push({ id: v.id, quantity: c.n });
      });
      return items;
    }

    /* CTA final selon l'origine :
       - fiche produit (data-product-url) → « Ajouter au panier » : TOUS les pots du combo
         partent au panier, même parcours que le méga-menu (depuis la règle du
         conditionnement le moins cher, les combos à deux formats sont courants et le
         pré-remplissage d'un seul pot les tronquait). Tant que le catalogue n'est pas là,
         ou si aucun pot ne se résout, le lien pré-rempli (qfin/qlit/qqty, pot principal
         seulement) sert de repli,
       - méga-menu → bouton « Choisir ma teinte » ouvrant l'étape teinte. */
    function updateCta() {
      var link = root.querySelector('[data-quantite-cta-link]');
      var pick = root.querySelector('[data-quantite-cta-pick]');
      var fromProduct = !!root.dataset.productUrl;
      if (link) link.hidden = !fromProduct;
      if (pick) pick.hidden = fromProduct;
      if (fromProduct && link) {
        var p = primaryPot();
        var qs = lastReco ? ('?qfin=' + encodeURIComponent(lastReco.name) +
          (p ? '&qlit=' + p.pot + '&qqty=' + p.n : '')) : '';
        link.href = root.dataset.productUrl + qs;
        link.textContent = comboItems(originProduct()).length ? I18N.ctaAdd : I18N.ctaPrefilled;
      }
    }

    /* ---- Sélecteur de teinte (origine méga-menu) ---- */
    function teinteState(msg) {
      var s = root.querySelector('[data-teinte-state]');
      if (s) { s.textContent = msg || ''; s.hidden = !msg; }
    }
    function optionPos(product, re) {
      var opts = product.options || [];
      for (var i = 0; i < opts.length; i++) {
        var o = opts[i];
        var name = (o && (o.name || o)) || '';
        if (re.test(String(name))) return (o && o.position) || (i + 1);
      }
      return null;
    }
    function hasFinitionOption(p) { return optionPos(p, /finition/i) != null; }
    /* Une teinte = produit ayant les DEUX options Finition × Litrage
       (exclut nuanciers / coffrets / vernis qui n'ont qu'une option « Title »). */
    function isTeinte(p) {
      return optionPos(p, /finition/i) != null && optionPos(p, /litrage|litre|conditionn/i) != null;
    }
    function teinteImage(p) {
      if (p.featured_image) return p.featured_image;
      if (p.images && p.images.length) return (typeof p.images[0] === 'string' ? p.images[0] : p.images[0].src);
      return '';
    }
    /* Résout la variante (finition + litrage en litres) d'un produit teinte. */
    function resolveVariant(product, finName, litres) {
      var finPos = optionPos(product, /finition/i);
      var litPos = optionPos(product, /litrage|litre|conditionn/i);
      var wantFin = normalizeFin(finName);
      var vs = product.variants || [];
      for (var i = 0; i < vs.length; i++) {
        var v = vs[i];
        if (finPos && normalizeFin(v['option' + finPos]) !== wantFin) continue;
        if (litPos && Math.abs(litresFromLabel(v['option' + litPos]) - litres) > 1e-6) continue;
        return v;
      }
      return null;
    }
    /* Une teinte est proposée si elle a ≥1 variante dispo dans la finition choisie. */
    function teinteOffersFinition(product, finName) {
      var finPos = optionPos(product, /finition/i);
      var wantFin = normalizeFin(finName);
      return (product.variants || []).some(function (v) {
        return v.available !== false && (!finPos || normalizeFin(v['option' + finPos]) === wantFin);
      });
    }
    /* Source des teintes (paginée, garde-fou 6 pages) : un réglage de collection
       s'il est fourni, sinon TOUS les produits (les teintes sont réparties sur
       plusieurs collections designer — pas de collection unique). */
    function fetchTeintes() {
      var handle = root.dataset.teintesCollection || '';
      var base = handle ? ('/collections/' + encodeURIComponent(handle) + '/products.json') : '/products.json';
      var all = [];
      function page(n) {
        return fetch(base + '?limit=250&page=' + n, { headers: { Accept: 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
          .then(function (d) {
            var prods = (d && d.products) || [];
            all = all.concat(prods);
            if (prods.length === 250 && n < 6) return page(n + 1);
            return all;
          });
      }
      return page(1);
    }
    /* Charge le catalogue une seule fois (promesse mémoïsée) : alimente les teintes
       ET les prix live. Préchauffé à l'ouverture → les prix sont prêts à l'étape
       finale, et l'étape teinte réutilise la même donnée. */
    function loadCatalog() {
      if (catalogPromise) return catalogPromise;
      catalogPromise = fetchTeintes().then(function (products) {
        products = products || [];
        teintesCache = products.filter(isTeinte);
        if (!LIVE_PRICES) LIVE_PRICES = buildLivePrices(products);
        return products;
      }).catch(function (e) { catalogPromise = null; throw e; });
      return catalogPromise;
    }
    function loadTeintes() {
      if (teintesCache) { renderTeintes(); return; }
      teinteState(I18N.teinteLoading);
      loadCatalog().then(renderTeintes).catch(function () {
        var grid = root.querySelector('[data-teinte-grid]');
        if (grid) {
          grid.innerHTML = '<p class="argile-finder__teintes-state">' + escapeHtml(I18N.teinteError) + '</p>' +
            '<a class="button-secondary" href="' + locURL('/collections/teintes') + '">' + escapeHtml(I18N.teinteBrowse) + '</a>';
        }
      });
    }
    function renderTeintes() {
      var grid = root.querySelector('[data-teinte-grid]');
      if (!grid || !teintesCache || !lastReco) return;
      var fin = lastReco.name;
      var list = teintesCache.filter(function (p) { return teinteOffersFinition(p, fin); });
      if (!list.length) {
        grid.innerHTML = '<p class="argile-finder__teintes-state">' + escapeHtml(I18N.teinteNone) + '</p>';
        return;
      }
      grid.innerHTML = list.map(function (p) {
        var img = teinteImage(p);
        var imgUrl = img ? (img.indexOf('?') === -1 ? img + '?width=200' : img) : '';
        return '<button type="button" class="argile-finder__teinte" data-teinte data-handle="' +
          escapeHtml(p.handle) + '" title="' + escapeHtml(p.title) + '">' +
          (imgUrl ? '<span class="argile-finder__teinte-img" style="background-image:url(' + escapeHtml(imgUrl) + ')"></span>'
                  : '<span class="argile-finder__teinte-img"></span>') +
          '<span class="argile-finder__teinte-name">' + escapeHtml(p.title) + '</span></button>';
      }).join('');
    }
    /* Clic teinte : résout chaque pot du combo → ajout panier (items) → ouverture du
       TIROIR (pas de redirect /cart, pour conserver le contexte et le combo complet).
       Réutilise le pattern de la fiche produit (argile-product.js) : add.js avec les
       `sections` cart-items rendues → event `cart:update` (morph du tiroir + recharge
       du cross-sell) → ouverture du tiroir une fois le panel complet. */
    function addTeinteToCart(handle, btn) {
      var product = (teintesCache || []).filter(function (p) { return p.handle === handle; })[0];
      if (!product || !lastReco) return;
      var items = comboItems(product);
      if (!items.length) {
        // Aucun format dispo pour cette teinte → repli sur la fiche produit.
        window.location.href = locURL('/products/' + handle);
        return;
      }
      if (btn) btn.setAttribute('aria-busy', 'true');

      // Sections cart-items à re-rendre → morph propre du tiroir (pas de re-fetch).
      var sectionIds = [];
      document.querySelectorAll('cart-items-component').forEach(function (el) {
        if (el.dataset && el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
      });

      // Ouvre le tiroir une seule fois : soit quand le cross-sell a fini de recharger
      // (event `argile:recos-ready`), soit au timeout de secours. On ferme d'abord la
      // modale, puis trigger.click() ouvre le tiroir (/open, idempotent).
      var opened = false;
      function openDrawer() {
        if (opened) return;
        opened = true;
        document.removeEventListener('argile:recos-ready', openDrawer);
        if (btn) btn.removeAttribute('aria-busy');
        close();
        var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
        if (trigger) trigger.click();
      }

      var addUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add';
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ items: items, sections: sectionIds.join(',') }),
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.addEventListener('argile:recos-ready', openDrawer);
            setTimeout(openDrawer, 1200);
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: 'argile-quantite-finder',
                data: { source: 'argile-quantite-finder', itemCount: cart.item_count, sections: res.sections },
              },
            }));
          });
        })
        .catch(function () {
          // Échec réseau : on ne fige pas la modale, le client peut re-cliquer.
          if (btn) btn.removeAttribute('aria-busy');
        });
    }

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isInline = root.classList.contains('argile-finder--inline');
    var closeTimer = null;
    // Mode EN LIGNE : le finder vit dans une page dédiée, à côté d'un hero.
    function heroEl() {
      var page = root.closest('[data-finder-page]');
      return page ? page.querySelector('[data-finder-hero]') : null;
    }
    function open(opts) {
      opts = (typeof opts === 'string') ? { variantId: opts } : (opts || {});
      lastFocus = document.activeElement;
      root.dataset.variantId = opts.variantId || '';
      root.dataset.productUrl = opts.productUrl || '';
      root.dataset.productTitle = opts.productTitle || '';
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      reset();
      // Retour fiche produit : la finition déjà choisie dans le dropdown
      // pré-sélectionne l'étape 2 (l'utilisateur n'a pas à la re-choisir).
      if (opts.currentFinition) {
        var pc = finitionCodeFromName(opts.currentFinition);
        if (pc) answers.finition = pc;
      }
      loadCatalog().catch(function () {}); // préchauffe prix live + teintes
      applyHeroImage();
      // EN LIGNE : pas de pop-in — on masque le hero et le finder le remplace dans
      // le flux (pas d'overlay, pas de verrou de défilement).
      if (isInline) {
        var h = heroEl();
        if (h) h.hidden = true;
        root.hidden = false;
        goto('q1');
        root.scrollIntoView({ block: 'start' });
        return;
      }
      root.hidden = false;
      document.documentElement.classList.add('argile-finder-open');
      // 2 frames : peindre l'état fermé (translateX(100%)) puis .is-open pour
      // que la transition d'entrée démarre (sinon saut sans anim depuis display:none).
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { root.classList.add('is-open'); });
      });
      goto('q1');
      var close = root.querySelector('[data-finder-close]');
      if (close) close.focus();
    }
    function close() {
      root.classList.remove('is-open');
      document.documentElement.classList.remove('argile-finder-open');
      var finish = function () { root.hidden = true; closeTimer = null; };
      // Anim de sortie seulement en mode panel (drawer) ; sinon fermeture immédiate.
      if (reduceMotion || !root.classList.contains('argile-finder--panel')) finish();
      else { if (closeTimer) clearTimeout(closeTimer); closeTimer = setTimeout(finish, 360); }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    /* ---- Steppers ▲▼ + ajout/suppression surfaces + navigation (délégué) ---- */
    root.addEventListener('click', function (e) {
      var step = e.target.closest('[data-num-step]');
      if (step) {
        var box = step.closest('.argile-finder__num');
        var input = box ? box.querySelector('input') : null;
        if (input) {
          var delta = parseInt(step.getAttribute('data-num-step'), 10) || 0;
          input.value = Math.max(0, (parseFloat(input.value) || 0) + delta);
          updateTotal();
        }
        return;
      }
      if (e.target.closest('[data-add-surface]')) {
        if (surfaceTpl) {
          root.querySelector('[data-surfaces]').appendChild(surfaceTpl.content.cloneNode(true));
          renumber(); updateTotal();
        }
        return;
      }
      if (e.target.closest('[data-add-subtract]')) {
        if (subtractTpl) {
          root.querySelector('[data-subtracts]').appendChild(subtractTpl.content.cloneNode(true));
          renumber(); updateTotal();
        }
        return;
      }
      var rm = e.target.closest('[data-remove-surface], [data-remove-subtract]');
      if (rm) {
        var rowToRemove = rm.closest('[data-surface], [data-subtract-row]');
        if (rowToRemove) rowToRemove.remove();
        renumber(); updateTotal();
        return;
      }
      if (e.target.closest('[data-finder-restart]')) { reset(); goto('q1'); return; }
      if (e.target.closest('[data-quantite-cta-pick]')) { goto('teinte'); return; }
      var teinteBtn = e.target.closest('[data-teinte]');
      if (teinteBtn) { addTeinteToCart(teinteBtn.dataset.handle, teinteBtn); return; }
      var gotoBtn = e.target.closest('[data-finder-goto]');
      if (gotoBtn) { goto(gotoBtn.getAttribute('data-finder-goto')); return; }
      if (e.target.closest('[data-finder-next]')) { goto(nextOf(current)); return; }
      if (e.target.closest('[data-finder-prev]')) { goto(prevOf(current)); return; }
    });

    root.addEventListener('input', function (e) {
      if (e.target.closest('[data-dim]')) updateTotal();
    });

    /* ---- Support (cartes radio, markup statique) ---- */
    root.querySelectorAll('[data-finder-options]').forEach(function (group) {
      group.querySelectorAll('[data-finder-option]').forEach(function (opt) {
        opt.addEventListener('click', function () {
          group.querySelectorAll('[data-finder-option]').forEach(function (o) {
            o.classList.toggle('is-selected', o === opt);
            o.setAttribute('aria-checked', o === opt ? 'true' : 'false');
          });
          answers.support = opt.dataset.support || '';
          syncNextEnabled('q2');
        });
      });
    });

    /* ---- Fiche produit : le CTA ajoute le combo complet au panier quand il se résout,
       sinon il laisse le lien pré-rempli naviguer (cf. updateCta). ---- */
    var ctaLink = root.querySelector('[data-quantite-cta-link]');
    if (ctaLink) {
      ctaLink.addEventListener('click', function (e) {
        var product = originProduct();
        if (!comboItems(product).length) return;
        e.preventDefault();
        addTeinteToCart(product.handle, ctaLink);
      });
    }

    /* ---- Fermeture ---- */
    root.querySelectorAll('[data-finder-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });

    root._open = open;
  }

  document.addEventListener('click', function (e) {
    var trig = e.target.closest('[data-quantite-finder-open], a[href="#quantite-finder"]');
    if (!trig) return;
    e.preventDefault();
    var root = document.querySelector('[data-argile-quantite]');
    var curFin = (document.querySelector('[data-argile-product] [data-finition]') || {}).value || '';
    if (root && root._open) root._open({
      variantId: trig.getAttribute('data-variant-id'),
      productUrl: trig.getAttribute('data-product-url'),
      productTitle: trig.getAttribute('data-product-title'),
      currentFinition: curFin,
    });
  });

  function init() { document.querySelectorAll('[data-argile-quantite]').forEach(initQuantite); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
